import { render, staticRenderFns } from "./CompareContent.vue?vue&type=template&id=3f78fd64&scoped=true&"
import script from "./CompareContent.vue?vue&type=script&lang=js&"
export * from "./CompareContent.vue?vue&type=script&lang=js&"
import style0 from "./CompareContent.vue?vue&type=style&index=0&id=3f78fd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78fd64",
  null
  
)

export default component.exports